import type { MantineThemeOverride } from "@mantine/core";

export const themeComponents: MantineThemeOverride["components"] = {
    ActionIcon: {
        defaultProps: {
            radius: "xs",
            variant: "subtle",
            size: "lg",
        },
    },
    Badge: {
        defaultProps: {
            radius: "xs",
            variant: "default",
        },
    },
    Button: {
        defaultProps: {
            radius: "xs",
            fw: 600,
        },
    },
    Card: {
        defaultProps: {
            withBorder: true,
            radius: "sm",
            shadow: "sm",
            padding: "lg",
        },
    },
    Modal: {
        defaultProps: {
            centered: true,
            radius: "sm",
            overlayProps: {
                backgroundOpacity: 0.55,
                blur: 4,
            },
        },
    },
    Paper: {
        defaultProps: {
            withBorder: true,
            radius: "sm",
            shadow: "sm",
            p: "lg",
        },
    },
    Switch: {
        defaultProps: {
            color: "accent",
        },
    },
    Tabs: {
        defaultProps: {
            color: "brand",
        },
    },
    TextInput: {
        defaultProps: {
            radius: "xs",
            size: "md",
        },
    },
    Textarea: {
        defaultProps: {
            radius: "xs",
            size: "md",
        },
    },
};
